import React from "react";
import "./TradeTable.scss";
import ReactTable from "../../../ReactTable/ReactTable";
import moment from "moment";
const TradeTable = ({ selectedDateValue }) => {
  const columns = [
    {
      Header: "Open Time",
      accessor: "date",
      Cell: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY / HH:mm:ss") : "-";
      },
    },
    // {
    //   Header: "Ticker",
    //   accessor: "ticker",
    // },
    {
      Header: "Action",
      accessor: "trade_side",
    },
    {
      Header: "Symbol",
      accessor: "symbol",
    },
    {
      Header: "Volume",
      accessor: "volume",
    },
    {
      Header: "P&L",
      accessor: "profit",
      Cell: ({ value }) => (
        <div
          className={`${value > 0 ? "profit" : value < 0 ? "loss" : "normal"}`}
        >
          {value >= 0
            ? `$${value.toFixed(2)}`
            : `-$${Math.abs(value).toFixed(2)}`}
        </div>
      ),
    },
    // {
    //   Header: "N ROI",
    //   accessor: "nRoi",
    // },
    {
      Header: "Commission",
      accessor: "commission",
    },
    // {
    //   Header: "Trade Duration",
    //   accessor: "tradeDuration",
    // },
  ];

  const data = [
    {
      openTime: "10:23:08",
      ticker: "NAS100",
      action: "Buy",
      instrument: "NASDAQ cfd",
      volume: 10,
      netPnl: 223.45,
      nRoi: "0.02%",
      commission: "--",
      tradeDuration: "$0",
    },
    {
      openTime: "10:23:08",
      ticker: "NAS100",
      action: "Sell",
      instrument: "NASDAQ cfd",
      volume: 10,
      netPnl: -223.45,
      nRoi: "2.02%",
      commission: "--",
      tradeDuration: "$0",
    },
    {
      openTime: "10:23:08",
      ticker: "NAS100",
      action: "Buy",
      instrument: "NASDAQ cfd",
      volume: 10,
      netPnl: 223.45,
      nRoi: "0.02%",
      commission: "--",
      tradeDuration: "$0",
    },
  ];

  return (
    <div className="tradeTableContainer">
      <div className="tradeTableWrapper">
        <ReactTable columns={columns} data={selectedDateValue || []} />
      </div>
    </div>
  );
};

export default TradeTable;
